<template>
    <div class="p-4 shadow mx-2">
        <h3 class="uppercase bg-blue-600 text-gray-100 font-thin tracking-wide p-2">
            {{ title }}
        </h3>
        <ul class="list-reset mt-4 font-thin text-gray-800 pl-2 admin-widget-list">
            <slot name="links"></slot>
        </ul>
    </div>
</template>

<script>
    export default {
        props: ['title']
    }
</script>